export enum KeybePhoneSpecialCountriesEnum {
  Bahamanas = 'bahamas',
  SintMaarten = 'sint maarten',
  SaintLucia= 'saint lucia',
  AmericanSamoa = 'american samoa',
  Argentina = 'argentina',
  Mexico = 'mexico (méxico)'
}
